import {
  BookingTypeButtonFlexBox,
  BookingTypeIcon,
  CentredPopupText,
  PopupBody
} from '../popup-styles'
import Popup from '../popup'
import SingleBookingIcon from '../assets/single-booking.svg'
import GroupBookingIcon from '../assets/group-booking.svg'
import BookingTypeButton from '../../../atoms/Button/booking-type-button'

type BookingTypePopupProps = {
  header: string
  singleSelectedAction: () => void
  groupSelectedAction: () => void
  availableSeats: number
}

const BookingTypePopup = ({
  header,
  singleSelectedAction,
  groupSelectedAction,
  availableSeats
}: BookingTypePopupProps) => {
  return (
    <Popup header={header}>
      <PopupBody>
        <CentredPopupText>Please select a booking type</CentredPopupText>
        <BookingTypeButtonFlexBox>
          <BookingTypeButton
            buttonText={'Single'}
            buttonIcon={
              <BookingTypeIcon
                data-testid={'single'}
                src={SingleBookingIcon}
                alt="single"
                width={'55px'}
                height={'55px'}
              />
            }
            onClick={singleSelectedAction}
          />
          <BookingTypeButton
            buttonText={'Group'}
            disable={availableSeats < 2}
            buttonIcon={
              <BookingTypeIcon
                data-testid={'group'}
                src={GroupBookingIcon}
                alt="group"
                width={'65px'}
                height={'55px'}
              />
            }
            onClick={groupSelectedAction}
          />
        </BookingTypeButtonFlexBox>
      </PopupBody>
    </Popup>
  )
}

export default BookingTypePopup
